<template>
    <div class="post-wrap page-inner">
        <Title v-if="post">
            <h2>
                Case Study
            </h2>
            <h3 v-html="post.title.rendered"></h3>
        </Title>

        <Content v-if="post">
            <div class="box" v-html="content"></div>
        </Content>

        <RelatedItems
            v-if="related_items && related_items.length !== 0"
            :list="related_items"
        >
            <h2 class="related-title">
                See more
                <router-link to="/case-studies" id="case-studies-page"
                    >case studies</router-link
                >
            </h2>
        </RelatedItems>
        <Loading v-if="$store.state.is_loading" class="static" />
    </div>
</template>

<script>
import GetPreviewUrl from "@/utils/GetPreviewUrl";
import Title from "@/components/ui/Title.vue";
import Content from "@/components/ui/Content.vue";
import Link from "@/components/ui/Link.vue";
import PostNewsletter from "@/components/PostNewsletter.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import Loading from "@/components/Loading.vue";

export default {
    name: "single-case",

    data() {
        return {
            post: false,
            content: "",
            related_items: []
        };
    },

    components: {
        Content,
        Link,
        PostNewsletter,
        RelatedItems,
        Title,
        Loading
    },

    props: {
        slug: {
            type: String,
            default: ""
        }
    },

    watch: {
        "$route.params": {
            handler(params) {
                // console.log(this.$route.name);
                this.fetchData(params);
            },
            immediate: true
        }
    },

    methods: {
        strLimit(html) {
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            let str = tmp.textContent || tmp.innerText || "";
            if (str.length > 50) str = str.substring(0, 50);

            return str;
        },

        fetchData() {
            this.related_items = [];
            this.$store.state.is_loading = true;
            let api_obj = GetPreviewUrl("cases", this.slug);
            this.$ajax
                .get(api_obj.url, api_obj.head)
                .then(res => {
                    if (res.data.length === 0)
                        this.$router.replace("/page/404");

                    let image = "";

                    if (res.data[0].featured_image) {
                        image = `<div class="wp-caption">
                            <img src="${res.data[0].featured_image.url}">
                            <p class="wp-caption-text">${res.data[0].featured_image.alt}</p>
                        </div>`;
                    }

                    this.content = `
                ${image}
                ${res.data[0].content.rendered}`;

                    document.title =
                        window.globals.site_title +
                        " — " +
                        this.$decode(res.data[0].title.rendered);
                    this.post = res.data[0];
                    this.$store.state.is_loading = false;

                    if (
                        this.post.related_items &&
                        this.post.related_items.length !== 0
                    ) {
                        this.related_items = this.post.related_items;
                    }

                    if (
                        // this.post.category && this.post.category.length !== 0 &&
                        !this.post.related_items ||
                        3 > this.post.related_items.length
                    ) {
                        let per_page = 3;
                        if (
                            this.post.related_items &&
                            3 > this.post.related_items.length
                        )
                            per_page = 3 - this.post.related_items.length;

                        // this.$ajax.get(`/related-items?post_id=${this.post.id}&cat=${this.post.category[0].slug}&per_page=${per_page}`).then(res => {
                        this.$ajax
                            .get(
                                `/related-items?post_id=${this.post.id}&post_type=case&per_page=${per_page}`
                            )
                            .then(res => {
                                res.data.forEach(item => {
                                    this.related_items.push(item);
                                });
                            });
                    }
                })
                .catch(error => {
                    this.$router.replace("/page/404");
                });
        }
    }
};
</script>
<style lang="scss">
.post-info {
    margin: var(--padding) 0;
    text-align: center;

    .ui-button {
        margin: 0 auto var(--padding-50) auto;
        text-align: center;
        text-transform: uppercase;
        display: block;
        border-color: var(--black);
        max-width: 26rem;
    }
}

@media only screen and (max-width: 767px) {
    .page-single-case {
        .page-title h3 {
            margin-bottom: 1em;
        }
    }
}
</style>
